import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  const [showAdBanner, setShowAdBanner] = useState(true);
  const navigate = useNavigate();

  const team = [
    { name: 'Sarah Johnson', role: 'CEO & Founder', image: 'https://public.readdy.ai/ai/img_res/e2a7f2521d80174c20828bc92ce54e7f.jpg' },
    { name: 'Michael Chen', role: 'CTO', image: 'https://readdy.ai/api/search-image?query=professional%20tech%20executive%20portrait%20in%20modern%20office%20with%20clean%20white%20background&width=400&height=400&seq=team2&orientation=squarish' },
    { name: 'Emily Rodriguez', role: 'Head of Design', image: 'https://readdy.ai/api/search-image?query=professional%20designer%20portrait%20in%20modern%20office%20with%20clean%20white%20background&width=400&height=400&seq=team3&orientation=squarish' },
    { name: 'David Park', role: 'Marketing Director', image: 'https://readdy.ai/api/search-image?query=professional%20marketing%20executive%20portrait%20in%20modern%20office%20with%20clean%20white%20background&width=400&height=400&seq=team4&orientation=squarish' },
  ];

  const milestones = [
    { year: '2020', title: 'Company Founded', desc: 'Started with a vision to democratize access to premium digital products' },
    { year: '2021', title: 'Reached 1,000 Customers', desc: 'Expanded product catalog and launched professional services' },
    { year: '2022', title: 'International Expansion', desc: 'Opened operations in 15 countries across 4 continents' },
    { year: '2023', title: 'Award Recognition', desc: 'Named "Best Digital Marketplace" by Industry Leaders Magazine' },
    { year: '2024', title: '10,000+ Happy Customers', desc: 'Achieved 98% customer satisfaction and launched AI-powered recommendations' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Floating Advertisement Banner */}
      {showAdBanner && (
        <div className="fixed bottom-6 right-6 z-50 max-w-sm animate-slide-up">
          <div className="bg-gradient-to-br from-primary via-purple-600 to-accent-green rounded-2xl shadow-2xl overflow-hidden">
            <button
              onClick={() => setShowAdBanner(false)}
              className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full text-white transition-colors cursor-pointer z-10"
            >
              <i className="ri-close-line"></i>
            </button>
            
            <div className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                <span className="text-white text-xs font-bold uppercase tracking-wider">Hot Deal</span>
              </div>
              
              <h3 className="text-white font-bold text-xl mb-2">
                🔥 Limited Time Offers!
              </h3>
              
              <div className="space-y-3 mb-4">
                <div 
                  onClick={() => {
                    navigate('/products');
                    setShowAdBanner(false);
                  }}
                  className="bg-white/10 backdrop-blur-sm rounded-lg p-3 hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                      <i className="ri-macbook-line text-2xl text-white"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-white font-semibold text-sm">MacBook Pro 16"</p>
                      <p className="text-white/80 text-xs">Save $500 Today!</p>
                    </div>
                  </div>
                </div>
                
                <div 
                  onClick={() => {
                    navigate('/products');
                    setShowAdBanner(false);
                  }}
                  className="bg-white/10 backdrop-blur-sm rounded-lg p-3 hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                      <i className="ri-plane-line text-2xl text-white"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-white font-semibold text-sm">Maldives Luxury</p>
                      <p className="text-white/80 text-xs">Earn $1,500 Commission!</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <button
                onClick={() => {
                  navigate('/products');
                  setShowAdBanner(false);
                }}
                className="w-full py-3 bg-white text-primary rounded-lg font-bold hover:shadow-xl transition-all cursor-pointer whitespace-nowrap"
              >
                Shop Now <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="relative w-full h-96 rounded-3xl overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=successful%20diverse%20business%20team%20collaborating%20in%20modern%20bright%20office%20with%20laptops%20and%20digital%20devices%20showing%20teamwork%20innovation%20and%20professional%20atmosphere%20with%20clean%20white%20walls%20and%20natural%20lighting&width=1600&height=600&seq=abouthero&orientation=landscape"
              alt="About Us"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Empowering Businesses<br />
              <span className="text-gray-500 font-light italic">Through Digital Excellence</span>
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed mb-8">
              We're on a mission to make premium digital products and professional services accessible to businesses worldwide. Since 2020, we've helped over 10,000 companies transform their digital presence with competitive pricing and exceptional quality.
            </p>
            <div className="flex flex-wrap gap-6 justify-center text-left">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 text-primary rounded-lg">
                  <i className="ri-verified-badge-line text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Verified Quality</div>
                  <div className="text-sm text-gray-500">100% Authentic Products</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 text-primary rounded-lg">
                  <i className="ri-global-line text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Global Reach</div>
                  <div className="text-sm text-gray-500">Serving 15+ Countries</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 text-primary rounded-lg">
                  <i className="ri-customer-service-2-line text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">24/7 Support</div>
                  <div className="text-sm text-gray-500">Always Here to Help</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-24 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Our Story
              </h2>
              <div className="space-y-4 text-lg text-gray-600 leading-relaxed">
                <p>
                  Founded in 2020 during a time of unprecedented digital transformation, Digital Business was born from a simple yet powerful idea: premium digital solutions shouldn't come with premium price tags.
                </p>
                <p>
                  Our founder, Sarah Johnson, witnessed countless small businesses struggling to afford the digital tools they needed to compete. She assembled a team of passionate professionals who shared her vision of democratizing access to high-quality digital products and services.
                </p>
                <p>
                  What started as a small catalog of 50 products has grown into a comprehensive marketplace featuring over 500 premium digital solutions. We've served more than 10,000 satisfied customers across 15 countries, maintaining an impressive 98% satisfaction rate.
                </p>
                <p>
                  Today, we're not just a marketplace—we're a trusted partner in your digital journey, offering expert consultation, custom solutions, and ongoing support to ensure your success.
                </p>
              </div>
            </div>
            <div className="relative w-full h-96">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20digital%20business%20workspace%20with%20multiple%20screens%20showing%20analytics%20dashboards%20and%20creative%20projects%20in%20bright%20minimalist%20office%20with%20white%20walls%20and%20professional%20lighting&width=800&height=600&seq=story1&orientation=landscape"
                alt="Our Story"
                className="w-full h-full object-cover object-top rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Milestones Timeline */}
      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Our Journey
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Key milestones that shaped our growth and success
            </p>
          </div>

          <div className="relative">
            {/* Timeline Line */}
            <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-primary via-purple-400 to-primary"></div>

            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div
                  key={index}
                  className={`flex flex-col lg:flex-row gap-8 items-center ${
                    index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  }`}
                >
                  <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                    <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                      <div className="text-4xl font-bold text-primary mb-3">{milestone.year}</div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">{milestone.title}</h3>
                      <p className="text-gray-600">{milestone.desc}</p>
                    </div>
                  </div>

                  {/* Timeline Dot */}
                  <div className="hidden lg:flex w-16 h-16 bg-gradient-to-br from-primary to-purple-600 rounded-full items-center justify-center shadow-lg z-10">
                    <i className="ri-star-fill text-white text-2xl"></i>
                  </div>

                  <div className="flex-1"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Company Values */}
      <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-6">
              Our Core Values
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              The principles that guide every decision we make and every relationship we build
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-price-tag-3-line',
                title: 'Great Prices',
                desc: 'Competitive pricing without compromising quality. We negotiate directly with suppliers to pass savings to you.',
              },
              {
                icon: 'ri-star-line',
                title: 'Quality First',
                desc: 'Every product is vetted by our expert team. We only offer solutions we would use ourselves.',
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Customer Focus',
                desc: 'Your success is our success. Dedicated support team available 24/7 to assist with any questions.',
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Trust & Security',
                desc: 'Bank-level encryption and secure payment processing. Your data and transactions are always protected.',
              },
            ].map((value, index) => (
              <div
                key={index}
                className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-xl hover:bg-gray-700/50 transition-all hover:transform hover:scale-105"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-primary/20 text-primary rounded-lg mb-4">
                  <i className={`${value.icon} text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{value.title}</h3>
                <p className="text-gray-300 leading-relaxed">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-24 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Meet Our Leadership Team
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Passionate professionals with decades of combined experience, dedicated to your success
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div
                key={index}
                className="group text-center cursor-pointer"
              >
                <div className="relative w-48 h-48 mx-auto mb-4 rounded-full overflow-hidden ring-4 ring-gray-200 group-hover:ring-primary transition-all">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center pb-6">
                    <div className="flex gap-3">
                      <a
                        href="#"
                        className="w-10 h-10 bg-white text-primary rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                      >
                        <i className="ri-linkedin-fill"></i>
                      </a>
                      <a
                        href="#"
                        className="w-10 h-10 bg-white text-primary rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                      >
                        <i className="ri-twitter-x-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-1">
                  {member.name}
                </h3>
                <p className="text-sm text-gray-500">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Our Impact in Numbers
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Real results from real customers who trust us with their digital needs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { number: '10,000+', label: 'Happy Customers', icon: 'ri-user-smile-line', desc: 'Businesses transformed' },
              { number: '500+', label: 'Products & Services', icon: 'ri-shopping-bag-3-line', desc: 'Premium solutions' },
              { number: '98%', label: 'Satisfaction Rate', icon: 'ri-star-line', desc: 'Customer approval' },
              { number: '24/7', label: 'Customer Support', icon: 'ri-customer-service-2-line', desc: 'Always available' },
            ].map((stat, index) => (
              <div key={index} className="text-center p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 text-primary rounded-full mx-auto mb-4">
                  <i className={`${stat.icon} text-3xl`}></i>
                </div>
                <div className="text-5xl font-bold text-primary mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-900 font-bold text-lg mb-1">{stat.label}</div>
                <div className="text-gray-500 text-sm">{stat.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Why Businesses Choose Us
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We're more than just a marketplace—we're your partner in digital success
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-hand-coin-line',
                title: 'Best Price Guarantee',
                desc: 'Find a lower price elsewhere? We\'ll match it and give you an additional 5% discount.',
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Quality Assurance',
                desc: 'Every product undergoes rigorous testing by our expert team before being listed.',
              },
              {
                icon: 'ri-time-line',
                title: 'Instant Delivery',
                desc: 'Digital products delivered instantly to your email. No waiting, no delays.',
              },
              {
                icon: 'ri-refresh-line',
                title: '30-Day Money Back',
                desc: 'Not satisfied? Get a full refund within 30 days, no questions asked.',
              },
              {
                icon: 'ri-user-star-line',
                title: 'Expert Consultation',
                desc: 'Free consultation with our specialists to help you choose the right solutions.',
              },
              {
                icon: 'ri-award-line',
                title: 'Industry Recognition',
                desc: 'Award-winning service recognized by leading industry publications.',
              },
            ].map((feature, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-primary to-purple-600 text-white rounded-lg mb-4">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ready to Transform Your Business?
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Join over 10,000 satisfied customers who have already discovered the perfect blend of quality and affordability. Start your digital transformation journey today!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <a
              href="/products"
              className="px-8 py-4 bg-gradient-to-r from-primary to-purple-600 text-white rounded-lg font-semibold hover:shadow-xl transition-all cursor-pointer whitespace-nowrap"
            >
              Browse Products
            </a>
            <a
              href="/services"
              className="px-8 py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              View Services
            </a>
          </div>
          <p className="text-sm text-gray-500">
            <i className="ri-shield-check-line mr-1"></i>
            30-day money-back guarantee • Instant delivery • 24/7 support
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;